/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ timemark: NonNullable<unknown>, duration: NonNullable<unknown>, progress: NonNullable<unknown> }} Scene_Change_Detection_Progress_StatusInputs */



/**
* | output |
* | --- |
* | "Scanning: {timemark}/{duration} ({progress}%) done" |
*
* @param {Scene_Change_Detection_Progress_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_progress_status = /** @type {((inputs: Scene_Change_Detection_Progress_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Progress_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Analyse : ${i?.timemark}/${i?.duration} (${i?.progress}%) termine`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Scanvorgang: ${i?.timemark}/${i?.duration} (${i?.progress}%) abgeschlossen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Scansione: ${i?.timemark}/${i?.duration} (${i?.progress}%) completata`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Сканирование: ${i?.timemark}/${i?.duration} (${i?.progress}%) выполнено`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Escaneo: ${i?.timemark}/${i?.duration} (${i?.progress}%) realizado`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`扫描完成：${i?.timemark}/${i?.duration} (${i?.progress}%)`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`スキャン中: ${i?.timemark}/${i?.duration} (${i?.progress}%) 完了`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`स्कैनिंग: ${i?.timemark}/${i?.duration} (${i?.progress}%) पूर्ण`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Escaneamento: ${i?.timemark}/${i?.duration} (${i?.progress}%) concluído`)
	return /** @type {LocalizedString} */ (`Scanning: ${i?.timemark}/${i?.duration} (${i?.progress}%) done`)
});